import React from 'react';

import { SVGComponentProps } from './svg.types';

const CsvSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="62"
        height="63"
        viewBox="0 0 62 63"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1938_64949)">
          <rect width="62" height="62" rx="4" fill="#F9FAFB" />
          <path
            d="M37.6032 15.5597C37.2305 15.2006 36.7331 15 36.2156 15H22.9708C21.0407 15 19.4824 16.4656 19.4824 18.323V28.3304H37.9731C40.2518 28.3304 42.1137 30.1001 42.1137 32.2931V39.7505C42.1137 41.9433 40.2518 43.747 37.9731 43.747H19.4932C19.5488 45.5504 21.0763 47 22.9708 47H43.5018C45.4317 47 46.9999 45.4761 46.9999 43.6184V25.4626C46.9999 24.9192 46.7788 24.3992 46.3875 24.0222L37.6032 15.5597ZM31.2652 24.5115H23.8855C23.4779 24.5115 23.1476 24.1781 23.1476 23.7859C23.1476 23.5896 23.23 23.405 23.3635 23.2767C23.4971 23.1482 23.6816 23.062 23.8855 23.062H31.2646C31.6721 23.062 32.0025 23.3947 32.0025 23.7869C32.0028 24.1789 31.6728 24.5115 31.2652 24.5115ZM31.2986 20.2331H23.9195C23.5119 20.2331 23.1816 19.9083 23.1816 19.5161C23.1816 19.3198 23.264 19.1486 23.3975 19.0203C23.5311 18.8917 23.7156 18.819 23.9195 18.819H31.2986C31.7061 18.819 32.0365 19.134 32.0365 19.5262C32.0365 19.9182 31.7061 20.2331 31.2986 20.2331ZM36.846 25.2187C36.5699 25.2187 36.346 24.9948 36.346 24.7187V18.5514C36.346 18.1109 36.8744 17.8857 37.1923 18.1907L43.6177 24.3579C43.9427 24.6698 43.7219 25.2187 43.2715 25.2187H36.846Z"
            fill="#9BADEE"
          />
          <path
            d="M40.3135 32.585C40.3135 31.1724 39.1237 30.0275 37.6562 30.0275H17.6573C16.1898 30.0275 15 31.1726 15 32.585V39.4922C15 40.9045 16.1898 42.0496 17.6573 42.0496H37.6562C39.124 42.0496 40.3135 40.9045 40.3135 39.4922V32.585ZM22.6579 38.6169C20.7474 38.6169 19.9392 37.3511 19.9318 36.0641C19.9245 34.7699 20.7989 33.4546 22.6579 33.4546C23.356 33.4546 24.0172 33.7092 24.5463 34.2113L23.8996 34.8124C23.5616 34.4941 23.1061 34.3456 22.6579 34.3456C21.4161 34.3456 20.8797 35.2367 20.8871 36.0641C20.8944 36.8844 21.3867 37.7401 22.6579 37.7401C23.1061 37.7401 23.6131 37.5633 23.9511 37.238L24.6124 37.8815C24.0834 38.3836 23.4 38.617 22.6579 38.617L22.6579 38.6169ZM27.1839 38.6311C26.1334 38.6311 25.3251 38.3199 24.9431 37.4148L25.7513 37.0117C25.9791 37.5562 26.5743 37.7967 27.1989 37.7967C27.8085 37.7967 28.3816 37.5916 28.3816 37.0541C28.3816 36.5874 27.8746 36.3965 27.1912 36.3257C26.1407 36.2055 25.1708 35.9368 25.1708 34.8265C25.1708 33.8082 26.2142 33.3909 27.1621 33.3839C27.9628 33.3839 28.7931 33.6031 29.1825 34.3669L28.411 34.7487C28.2347 34.4659 27.7497 34.1971 27.1913 34.1971C26.4714 34.1971 26.1261 34.4871 26.1261 34.8548C26.1261 35.2862 26.6552 35.4064 27.2724 35.4771C28.3449 35.6044 29.3442 35.8731 29.3442 37.0541C29.3442 38.1573 28.3302 38.6312 27.184 38.6312L27.1839 38.6311ZM32.8858 38.549H31.8792L29.7412 33.5634H30.8285L32.3789 37.4175L33.9367 33.5634H35.0242L32.8858 38.549Z"
            fill="#9BADEE"
          />
          <rect x="0.5" y="0.5" width="61" height="61" rx="3.5" stroke="#F6F7F9" />
        </g>
        <defs>
          <filter
            id="filter0_d_1938_64949"
            x="0"
            y="0"
            width="62"
            height="63"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.941176 0 0 0 0 0.945098 0 0 0 0 0.960784 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1938_64949"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1938_64949"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </span>
  );
};

export default CsvSVG;
